"use client";
/*
 * Documentation:
 * PRINT_DC_Excursion_Card — https://app.subframe.com/4f62853ee923/library?component=PRINT_DC_Excursion_Card_d42a7389-2b98-4679-be52-67e9c6c0fb5c
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface Print_Dc_Excursion_CardRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  subtitle?: React.ReactNode;
  heading?: React.ReactNode;
  variant?: "default";
  className?: string;
}

const Print_Dc_Excursion_CardRoot = React.forwardRef<
  HTMLDivElement,
  Print_Dc_Excursion_CardRootProps
>(function Print_Dc_Excursion_CardRoot(
  {
    subtitle,
    heading,
    variant = "default",
    className,
    ...otherProps
  }: Print_Dc_Excursion_CardRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "group/d42a7389 flex h-full w-full cursor-pointer flex-col items-start gap-48 rounded-md bg-neutral-50 px-4 py-4 comp-excursion-card hover:bg-transparent",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <div className="flex flex-col items-start gap-2">
        {subtitle ? (
          <span className="text-caption font-caption text-default-font comp-excursion-card-title">
            {subtitle}
          </span>
        ) : null}
        {heading ? (
          <span className="text-heading-3 font-heading-3 text-default-font comp-excursion-card-title">
            {heading}
          </span>
        ) : null}
      </div>
    </div>
  );
});

export const Print_Dc_Excursion_Card = Print_Dc_Excursion_CardRoot;
